import { useState } from "react";
import FadeInSection, { FadeInType } from "../wrappers/FadeInSection";
export default function About() {
  const [activeIndex, setActiveIndex] = useState(0);

  const tabTitles = ["About Us", "Our Goal"]; // max character length 9
  const tabContents = [
    // FIRST ONE
    <div className="md:-mx-4 mx-1 flex w-full flex-wrap items-center pt-[70px]">
      <div className="w-full md:px-4 px-1 lg:w-1/2">
        <div className="relative z-30 mb-14 h-[350px] md:h-[490px] lg:max-w-[400px] max-w-[300px] lg:mb-0 lg:w-full w-5/6">
          <div className="absolute top-1/2 right-0 z-10 -translate-y-1/2">
            <img src="/assets/home/hero/image_5.jpeg" alt="about-image" className="aspect-[3/4] object-cover" />
            <div className="border-primary/10 bg-primary/5 absolute -top-5 left-5 lg:-left-5 -z-10 h-full w-full border backdrop-blur-[6px] dark:border-white/10 dark:bg-white/10"></div>
          </div>
        </div>
      </div>
      <div className="w-full md:px-4 px-1 lg:w-1/2">
        <div className="max-w-[565px] lg:ml-auto">
          <h2 className="font-main text-dark mb-8 text-2xl font-bold sm:text-[40px] sm:leading-[50px] dark:text-white">
            We are a student-led STEM organization.
          </h2>
          <p className="text-dark-text mb-6 text-base">
            At STEM Enrichment of New Jersey, we believe that scientific
            curiosity begins in childhood at elementary-age learners, long
            before students ever step into a high school lab.
          </p>
          <p className="text-dark-text mb-6 text-base">
            Our mission is not about stacking resumes or checking boxes for
            college applications—it’s about something far greater: authentic
            passion and real impact.
          </p>
          <p className="text-dark-text text-base">
            Through hands-on workshops, coding challenges, and all sorts of
            other outreach, we spark curiosity and problem-solving in young
            minds.
          </p>
        </div>
      </div>
    </div>,
    // SECOND ONE
    <div className="md:-mx-4 mx-1 flex w-full flex-wrap items-center pt-[70px]">
      <div className="w-full md:px-4 px-1 lg:w-1/2">
        <div className="relative z-30 mb-14 h-[350px] md:h-[490px] lg:max-w-[400px] max-w-[300px] lg:mb-0 lg:w-full w-5/6">
          <div className="absolute top-1/2 right-0 z-10 -translate-y-1/2">
            <img src="/assets/home/hero/IMG_6795.jpg" alt="about-image" className="aspect-[3/4] object-cover" />
            <div className="border-primary/10 bg-primary/5 absolute -top-5 left-5 lg:-left-5 -z-10 h-full w-full border backdrop-blur-[6px] dark:border-white/10 dark:bg-white/10"></div>
          </div>
        </div>
      </div>
      <div className="w-full md:px-4 px-1 lg:w-1/2">
        <div className="max-w-[565px] lg:ml-auto">
          <h2 className="font-main text-dark mb-8 text-2xl font-bold sm:text-[40px] sm:leading-[50px] dark:text-white">
            On a mission to empower youth in STEM...
          </h2>
          <p className="text-dark-text mb-6 text-base">
            STEM is the future, so we believe in providing education and
            opportunity to students of all backgrounds. We offer the resources
            to help them succeed and reach their aspirations.
          </p>
          <p className="text-dark-text mb-6 text-base">
            Everyone involved with this organization is committed to making a
            difference in our communities. As students, we know the difficulty
            of finding opportunities outside of school.
          </p>
          <p className="text-dark-text text-base">
            Our goal is to inspire STEM literacy and excitement across New
            Jersey.
          </p>
        </div>
      </div>
    </div>,
    // LAST ONE (NOT IN USE RN)
    <div className="md:-mx-4 mx-1 flex w-full flex-wrap items-center pt-[70px]">
      <div className="w-full md:px-4 px-1 lg:w-1/2">
        <div className="relative z-30 mb-14 h-[350px] md:h-[490px] lg:max-w-[400px] max-w-[300px] lg:mb-0 lg:w-full w-5/6">
          <div className="absolute top-1/2 right-0 z-10 -translate-y-1/2">
            <img src="/assets/home/closeup.jpg" alt="about-image" />
            <div className="border-primary/10 bg-primary/5 absolute -top-5 left-5 lg:-left-5 -z-10 h-full w-full border backdrop-blur-[6px] dark:border-white/10 dark:bg-white/10"></div>
          </div>
        </div>
      </div>
      <div className="w-full md:px-4 px-1 lg:w-1/2">
        <div className="max-w-[565px] lg:ml-auto">
          <h2 className="font-main text-dark mb-8 text-2xl font-bold sm:text-[40px] sm:leading-[50px] dark:text-white">
            We are a student-led STEM organization.
          </h2>
          <p className="text-dark-text mb-6 text-base">
            At STEM Enrichment of New Jersey, we believe that scientific
            curiosity begins in childhood at elementary-age learners, long
            before students ever step into a high school lab.
          </p>
          <p className="text-dark-text mb-6 text-base">
            Our mission is not about stacking resumes or checking boxes for
            college applications—it’s about something far greater: authentic
            passion and real impact.
          </p>
          <p className="text-dark-text text-base">
            Through hands-on workshops, coding challenges, and all sorts of
            other outreach, we spark curiosity and problem-solving in young
            minds.
          </p>
        </div>
      </div>
    </div>,
  ];
  return (
    <section id="about" className="pt-14 sm:pt-20 lg:pt-[130px]">
      <div className="px-4 mx-auto w-5/6 xl:w-3/5">
        <FadeInSection distance={FadeInType.SHORT}>
          <div className="relative mx-auto mb-12 pt-6 text-center lg:mb-20 lg:pt-16">
            <span className="title"> ABOUT US </span>
            <h2 className="font-main text-dark mx-auto mb-5 max-w-[570px] text-3xl font-semibold sm:text-4xl md:text-[50px] md:leading-[60px] dark:text-white">
              Every story starts somewhere, here’s ours.
            </h2>
            <p className="text-dark-text mx-auto max-w-[570px] text-base">
              Ours began with a group of people who cared deeply and believed in
              something better. That belief turned into action, and the action
              became a community.
            </p>
          </div>

          <div className="relative z-10 overflow-hidden rounded-sm px-8 pt-0 pb-8 md:px-[70px] md:pb-[70px] lg:px-[60px] lg:pb-[60px] xl:px-[70px] xl:pb-[70px]">
            <div className="absolute bottom-0 left-1/2 -z-10 -translate-x-1/2">
              <svg
                width="1200"
                height="600"
                viewBox="0 0 1200 600"
                fill="none"
                className="overflow-visible"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.4" filter="url(#filter1)">
                  <rect
                    x="460"
                    y="275"
                    width="285"
                    height="356.3568"
                    fill="url(#paint1)"
                  ></rect>
                </g>
                <defs>
                  <filter
                    id="filter1"
                    x="04"
                    y="-180"
                    width="1200"
                    height="1235.234"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood
                      floodOpacity="0"
                      result="BackgroundImage"
                    ></feFlood>
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="BackgroundImage"
                      result="shape"
                    ></feBlend>
                    <feGaussianBlur stdDeviation="225"></feGaussianBlur>
                  </filter>
                  <linearGradient
                    id="paint1"
                    x1="430"
                    y1="350"
                    x2="578"
                    y2="860"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#ABBCFF"></stop>
                    <stop offset="0.859375" stopColor="#4A6CF7"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="tabButtons flex w-full items-center justify-around">
              {tabTitles.map((title, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`px-4 py-2 border-b-2 transition-colors pointer ${
                    activeIndex === index
                      ? "font-main hover:border-primary hover:text-primary dark:hover:border-primary w-full border-b px-2 pt-8 pb-6 text-base font-medium lg:pt-9 lg:pb-7 text-primary border-primary"
                      : "font-main hover:border-primary hover:text-primary dark:hover:border-primary w-full border-b px-2 pt-8 pb-6 text-base font-medium lg:pt-9 lg:pb-7 dark:border-[#4B4E56] dark:text-white"
                  }`}
                >
                  {title}
                </button>
              ))}
            </div>
            <div className="w-full">
              {tabContents.map((content, index) => (
                <div
                  key={index}
                  className="tabPanel"
                  style={{ display: activeIndex === index ? "flex" : "none" }}
                >
                  {content}
                </div>
              ))}
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
